import React from "react";
import { connect } from "react-redux";
import { getFormValues, change } from "redux-form";
import { push } from "react-router-redux";

import Affix from "../../components/common/Affix";
import QuestionnaireMandaysCalculationForm from "../../components/Questionnaires/QuestionnaireMandaysCalculationForm";

import {
  mandDayCreateSelector,
  getMandays,
} from "../../selectors/questionnaires";

import phases from "../../const/phases";
import allocateMandays from "../../const/allocateMandays";
import { roundBy } from "../../const/helper";

export function QuestionnaireMandaysCalculation(props) {
  const { questionnaire, accessToken, formValue, manDayAdjustment, user } =
    props;

  const calculatedMandays = getMandays(questionnaire);
  const ateamMandays = (formValue && formValue.mandays_by_a_team) || 0;
  const roundedMandays = roundBy(
    (ateamMandays || calculatedMandays) * ((manDayAdjustment || 0) / 100 + 1),
    0.2
  );

  // useEffect(() => {
  //   if (me.data.role.includes('Customer')) {
  //     push('/questionnaires')
  //   }
  // }, me)

  function handleSubmit(e) {
    let target;
    const finalAdjustment =
      manDayAdjustment < -30
        ? -30
        : manDayAdjustment > 30
          ? 30
          : manDayAdjustment;
    let request = {
      id: questionnaire.id,
      detail: {
        a_team: e.a_team,
        mandays: calculatedMandays,
        mandays_by_a_team: e.mandays_by_a_team,
        mandays_roundup: e.mandays_by_a_team
          ? e.mandays_by_a_team
          : roundedMandays,
        mandays_adjustment: e.mandays_by_a_team ? 0 : finalAdjustment,
        reduction_factor: e.mandays_by_a_team ? [] : e.reduction_factor,
        enhancement_factor: e.mandays_by_a_team ? [] : e.enhancement_factor,
        addition_factor: e.mandays_by_a_team ? [] : e.addition_factor,
        additional_service: e.additional_service
          ? e.additional_service.map((x) => {
            return { ...x, type: "additional" };
          })
          : [],
        audit_cycle: e.audit_cycle.map((x) => {
          return { ...x, type: "certification" };
        }),
        audit_cycle_scheme: e.audit_cycle_scheme,
        surveillance_interval: e.surveillance_interval,
        include_recertification: e.include_recertification || "Yes",
        mandays_justification: e.mandays_justification,
        adjustment: null,
      },
    };

    if (e.advance) {
      if (
        ["Revision Draft", "Revision Need to Revise"].includes(
          questionnaire.status
        )
      ) {
        request.status = "Revision Created";
      } else {
        request.status = questionnaire?.log?.some(
          (x) => x.action === "to:Assigned"
        )
          ? "Assigned"
          : "Created";
      }
      request.detail.mandays_calculation_complete = true;
      target = `/questionnaires/${questionnaire.id}`;
    }

    return props.updateQuestionnaire(request, accessToken, target).then((x) => {
      props.fetchQuestionnaire(questionnaire.id, accessToken);
    });
  }

  return (
    <div className="tab-pane active">
      <h1>Mandays Calculation & Adjustment</h1>
      <div className="row">
        <div className="col-md-8">
          {user && user.data.role.includes("Customer") ? (
            <div>
              <p>
                Dear Customer, please wait for Sales personnel adjustment for
                this quotation prior publish.
              </p>
            </div>
          ) : (
            <div>
              <p>
                Dear Sales Personnel, please fill in the customer detail form.
              </p>
              { }
              <QuestionnaireMandaysCalculationForm
                onSubmit={handleSubmit.bind(this)}
                change={props.changeForm.bind(this)}
                integration={questionnaire.scopes.length > 1}
                hasATeam={formValue?.mandays_by_a_team}
                initialValues={{
                  a_team: questionnaire.detail.a_team,
                  mandays_by_a_team: questionnaire.detail.mandays_by_a_team,
                  reduction_factor: questionnaire.detail.reduction_factor,
                  enhancement_factor: questionnaire.detail.enhancement_factor,
                  addition_factor: questionnaire.detail.addition_factor,
                  additional_service: questionnaire.detail.additional_service,
                  audit_cycle: questionnaire.detail.audit_cycle,
                  audit_cycle_scheme: questionnaire.detail.audit_cycle_scheme,
                  surveillance_interval:
                    questionnaire.detail.surveillance_interval || 6,
                  include_recertification:
                    questionnaire.detail.include_recertification || "Yes",
                  mandays_justification:
                    questionnaire.detail.mandays_justification,
                  mandays: calculatedMandays,
                  advance: false,
                  // advance: questionnaire.detail.mandays_calculation_complete
                }}
                mandaysAllocation={allocateMandays(
                  phases,
                  roundedMandays,
                  questionnaire.scopes.length
                )}
                interval={
                  formValue && formValue.surveillance_interval
                    ? formValue.surveillance_interval
                    : 6
                }
                manDayAdjustment={manDayAdjustment}
                phases={phases}
                services={questionnaire.services}
                fileAPI={{
                  url: process.env.REACT_APP_BASE_API,
                  accessToken: accessToken,
                }}
              />
            </div>
          )}
        </div>
        <div className="col-md-4">
          {user && user.data.role !== "Customer" && (
            <div>
              <Affix offset={250}>
                <div className="widget">
                  <div className="widget-header">
                    <h3>
                      <i className="fa fa-tasks" /> Basic Data
                    </h3>{" "}
                    <em>- Summary of Tasks</em>
                  </div>
                  <div className="widget-content">
                    <dl>
                      <dt>Man Days Calculation by Formula</dt>
                      <dd>{calculatedMandays} mandays</dd>
                      {formValue && formValue.mandays_by_a_team && (
                        <span>
                          <dt>Man Days Calculation by A Team</dt>
                          <dd>{formValue.mandays_by_a_team} mandays</dd>
                        </span>
                      )}
                      {!formValue?.mandays_by_a_team && (
                        <>
                          <dt>Man Day Adjustment Percentage</dt>
                          <dd>{manDayAdjustment} %</dd>
                          <dt>Man Day Round Up</dt>
                          {questionnaire && <dd>{roundedMandays} mandays</dd>}
                        </>
                      )}
                    </dl>
                  </div>
                </div>
              </Affix>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    formValue: getFormValues("questionnaireAdjustmentForm")(state),
    manDayAdjustment: mandDayCreateSelector(state),
    me: state.auth.user,
    user: state.auth.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeForm: (form, field, value) => dispatch(change(form, field, value)),
    push: (to) => dispatch(push(to)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionnaireMandaysCalculation);
